import React from 'react';
import { ExperienceResource } from '../Types';

export type ExperienceContextType = {
  invitationUuid: string;
  experienceResource: ExperienceResource;
};

export const ExperienceContext = React.createContext<ExperienceContextType | null>(null);

export const ExperienceContextProvider = ExperienceContext.Provider;
